module.exports = __webpack_public_path__ + "static/media/duplicate2.070ecd85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/duplicate2.jpg
// module id = 1633
// module chunks = 0